// rtdb.ts
// This file initializes and exports the Firebase Realtime Database instance
// using the Firebase Modular SDK (v9+).

import { getDatabaseInstance } from './config';

// Export Database using lazy initialization with Proxy
// This ensures Database is initialized only when accessed, preventing chunking issues
let _databaseInstance: ReturnType<typeof getDatabaseInstance> | null = null;

export const RTDB = new Proxy({} as ReturnType<typeof getDatabaseInstance>, {
    get(_target, prop) {
        if (!_databaseInstance) {
            _databaseInstance = getDatabaseInstance();
        }
        return (_databaseInstance as any)[prop];
    },
    has(_target, prop) {
        if (!_databaseInstance) {
            _databaseInstance = getDatabaseInstance();
        }
        return prop in (_databaseInstance as any);
    },
    ownKeys(_target) {
        if (!_databaseInstance) {
            _databaseInstance = getDatabaseInstance();
        }
        return Object.keys(_databaseInstance as any);
    },
    getOwnPropertyDescriptor(_target, prop) {
        if (!_databaseInstance) {
            _databaseInstance = getDatabaseInstance();
        }
        return Object.getOwnPropertyDescriptor(_databaseInstance as any, prop);
    },
    getPrototypeOf() {
        if (!_databaseInstance) {
            _databaseInstance = getDatabaseInstance();
        }
        return Object.getPrototypeOf(_databaseInstance as any);
    }
});